
// login action types
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const LOG_OUT = 'LOG_OUT';

// signup
export const SIGNUP_START = 'SIGNUP_START';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';
export const CLEAR_AUTH_STATE = 'CLEAR_AUTH_STATE';

//theme 
export const CHANGE_PLAYGROUND_THEME = 'CHANGE_PLAYGROUND_THEME';